var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('main-visual'), _c('main-slides'), _c('main-membership'), _c('main-producing'), _c('main-partners'), _c('main-products'), _c('main-marks'), _c('main-section', [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.tempMsg
    }
  }, [_vm._v("OEM/ODM 문의하기")])], 1)], 1)], 1), _c('main-recruitment'), _vm._l(_vm.popups, function (popup) {
    return _c('popup-layer', {
      key: popup._id,
      attrs: {
        "popup": popup
      }
    });
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }